import { useState } from 'react';
import { exportToPDF, exportFinancialReportPDF } from '../utils/exportPDF';
import { exportToCSV, exportFinancialCSV } from '../utils/exportCSV';
import api from '../services/api';
import toast from 'react-hot-toast';
import { format } from 'date-fns';

export const useExport = () => {
  const [exporting, setExporting] = useState(false);

  const exportData = async (type, config) => {
    setExporting(true);
    try {
      const { endpoint, params, format: exportFormat, ...options } = config;
      
      // Busca dados se necessário
      let data = config.data;
      if (!data && endpoint) {
        const response = await api.get(endpoint, { params });
        data = response.data.data || response.data;
      }

      if (!data || data.length === 0) {
        toast.error('Não há dados para exportar');
        return;
      }

      // Exporta baseado no formato
      if (exportFormat === 'pdf') {
        exportToPDF(data, config.columns || [], options);
      } else if (exportFormat === 'csv') {
        exportToCSV(data, config.columns || [], options.filename);
      }

      toast.success(`${exportFormat.toUpperCase()} exportado com sucesso`);
    } catch (error) {
      toast.error('Erro ao exportar dados');
      console.error(error);
    } finally {
      setExporting(false);
    }
  };

  const exportFinancialReport = async (type, period, filters = {}) => {
    setExporting(true);
    try {
      let endpoint = '';
      let params = {};

      switch (type) {
        case 'dre':
          endpoint = `/movimentacoes/dre`;
          params = { mes: period.month, ano: period.year };
          break;
        case 'fluxo-caixa':
          endpoint = `/movimentacoes/fluxo-caixa`;
          params = {
            dataInicio: period.startDate,
            dataFim: period.endDate
          };
          break;
        case 'categoria':
          endpoint = `/movimentacoes/relatorio-categoria`;
          params = { mes: period.month, ano: period.year };
          break;
        default:
          endpoint = `/movimentacoes`;
          params = { ...filters, ...period };
      }

      const response = await api.get(endpoint, { params });
      const data = response.data;

      // Formata o período para o relatório
      const periodText = period.startDate && period.endDate
        ? `${format(new Date(period.startDate), 'dd/MM/yyyy')} a ${format(new Date(period.endDate), 'dd/MM/yyyy')}`
        : `${period.month}/${period.year}`;

      // Exporta o relatório financeiro
      exportFinancialReportPDF(data, periodText, type);
      
      toast.success('Relatório financeiro exportado com sucesso');
    } catch (error) {
      toast.error('Erro ao exportar relatório financeiro');
      console.error(error);
    } finally {
      setExporting(false);
    }
  };

  return {
    exportData,
    exportFinancialReport,
    exporting
  };
};